export default __webpack_public_path__ + "static/media/oph-coming-soon.013f2f88.jpg";